export default __webpack_public_path__ + "static/media/industrialControlSystem.27d7a964.svg";